var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { APP_STORE } from '@/stores/defs';
import { forEach, filter, findLastIndex, flatMap } from 'lodash';
var flowStateMixin = {
    computed: __assign({}, mapGetters({
        getFlows: APP_STORE.GET_FLOWS,
        getFlow: APP_STORE.GET_FLOW,
        getFlowStep: APP_STORE.GET_FLOW_STEP,
    }), { exitedAllFlows: function () {
            var flows = this.getFlows;
            var checkFlows = flatMap(flows, function (flow) {
                return flow.name;
            });
            return this.exitedFlows(checkFlows);
        },
        flowStillActive: function () {
            return !this.exitedAllFlows;
        } }),
    methods: __assign({}, mapActions({
        setFlow: APP_STORE.SET_FLOW,
        setFlowStep: APP_STORE.SET_FLOW_STEP,
    }), { getFlowState: function (name) {
            var flowState = this.getFlowStep(name, 'active');
            if (!flowState) {
                return false;
            }
            return flowState.value;
        },
        exitedFlows: function (names) {
            var _this = this;
            if (names === void 0) { names = []; }
            var remaining = filter(names, function (name) {
                var flowActive = _this.getFlowState(name);
                return flowActive;
            });
            remaining = remaining || [];
            return (remaining.length === 0);
        },
        getLastFlowIndex: function () {
            var flows = this.getFlows;
            if (!flows) {
                return false;
            }
            var index = findLastIndex(flows, function (flow) {
                var steps = flow.steps;
                var active = steps[0].value;
                if (!active) {
                    return true;
                }
                return false;
            });
            return index;
        },
        getLastActiveFlow: function () {
            // get first false value from the end
            var flows = this.getFlows;
            if (!flows) {
                return false;
            }
            var lastFlowIndex = this.getLastFlowIndex();
            if (lastFlowIndex === 0 || lastFlowIndex === -1) {
                return false;
            }
            return flows[lastFlowIndex];
        },
        resetLastActiveFlow: function () {
            var flows = this.getFlows;
            if (!flows) {
                return;
            }
            var index = this.getLastFlowIndex();
            var name = flows[index].name;
            this.setFlowStep({
                name: name,
                step: 'active',
                value: true,
            });
        },
        createStandardFlows: function (names) {
            var _this = this;
            forEach(names, function (name) {
                _this.setFlow({
                    name: name,
                    steps: [{
                            name: 'active',
                            value: true,
                        }],
                });
            });
        },
        exitAllFlows: function () {
            var _this = this;
            var names = ['greeting', 'locator', 'service'];
            forEach(names, function (name) {
                _this.setFlow({
                    name: name,
                    steps: [{
                            name: 'active',
                            value: false,
                        }],
                });
            });
        } }),
};
export default flowStateMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/flowStateMixin.ts
// module id = x1bm
// module chunks = 18